<template>
  <div>
    <div class="table-title">Public Information</div>
    <table class="attr-table">
      <tr>
        <td class="label">Company Name</td>
        <td colspan="2" v-if="company.name_hide === '0' || user.role_id < 3" :class="[company.name_hide === '0' ? '' : 'hide-name']">
          {{ company.name }}<span v-if="company.name2">&nbsp;({{ company.name2 }})</span>
        </td>
        <td colspan="2" v-else class="hide-name">&nbsp;</td>
        <td style="text-align:right">
          <el-button @click="edit" v-if="showPrivate">Edit</el-button>
        </td>
      </tr>
      <tr>
        <td class="label">Abbreviation</td>
        <td>{{ company.abbreviation }}</td>
        <td class="label" rowspan="5">Public Information</td>
        <td rowspan="5">{{ company.public_information }}</td>
      </tr>
      <tr>
        <td class="label">Country</td>
        <td style="width:350px">{{ company.country }}</td>
      </tr>
      <tr>
        <td class="label">Country Code</td>
        <td>{{ company.country_code }}</td>
      </tr>
      <tr>
        <td class="label">Customer Source</td>
        <td>{{ company.source }}</td>
      </tr>
      <tr>
        <td class="label">Automation</td>
        <td>Offer: <span style="color:blue;font-weight:bold;">{{ customerGroupListOffer.length }}</span> groups &nbsp; Require: <span style="color:blue;font-weight:bold;">{{ customerGroupListRequire.length }}</span> groups</td>
      </tr>
    </table>

    <el-row :gutter="10">
      <el-col :span="16">
        <div class="table-title" style="margin-top:10px;">Last Update</div>
        <table class="attr-table">
          <tr>
            <td class="label">Quotation:</td>
            <td>
              <table style="width:auto;">
                <tr>
                  <td v-for="(item, index) in lastOfferCateList" :key="index" style="border-right:1px solid #c3c3c2">{{ item.category_name }}</td>
                </tr>
                <tr>
                  <td v-for="(item, index) in lastOfferCateList" :key="index" style="border-right:1px solid #c3c3c2;border-bottom:0;">{{ item.last_date.substr(0, 10) }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="label">Requirement:</td>
            <td>
              <table style="width:auto;">
                <tr>
                  <td v-for="(item, index) in lastRequireCateList" :key="index" style="border-right:1px solid #c3c3c2">{{ item.category_name }}</td>
                </tr>
                <tr>
                  <td v-for="(item, index) in lastRequireCateList" :key="index" style="border-right:1px solid #c3c3c2;border-bottom:0;">{{ item.last_date.substr(0, 10) }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="label">PO:</td>
            <td>
              <table style="width:auto;">
                <tr>
                  <td v-for="(item, index) in lastPOCateList" :key="index" style="border-right:1px solid #c3c3c2">{{ item.category_name }}</td>
                </tr>
                <tr>
                  <td v-for="(item, index) in lastPOCateList" :key="index" style="border-right:1px solid #c3c3c2;border-bottom:0;">{{ item.last_date.substr(0, 10) }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="label">PI:</td>
            <td>
              <table style="width:auto;">
                <tr>
                  <td v-for="(item, index) in lastPICateList" :key="index" style="border-right:1px solid #c3c3c2">{{ item.category_name }}</td>
                </tr>
                <tr>
                  <td v-for="(item, index) in lastPICateList" :key="index" style="border-right:1px solid #c3c3c2;border-bottom:0;">{{ item.last_date.substr(0, 10) }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :span="8">
        <div class="table-title" style="margin-top:10px;">Sales Information</div>
        <table class="attr-table">
          <tr>
            <td class="label">Sales 1:</td>
            <td>{{ company.sales_name }}</td>
          </tr>
          <tr>
            <td class="label">Sales 2:</td>
            <td>{{ company.sales2_name }}</td>
          </tr>
          <tr>
            <td colspan="2" style="background:#fff;text-align:right;">Create by {{ company.create_oper_name }} at {{ company.create_time }}</td>
          </tr>
          <tr>
            <td colspan="2" style="background:#fff;text-align:right;">Modified by {{ company.update_oper_name }} at {{ company.update_time }}</td>
          </tr>
        </table>
      </el-col>
    </el-row>

    <div class="table-title" style="margin-top:10px;" v-if="showPrivate">Customer Class</div>
    <div style="padding:4px;background-color:#fff;border:1px solid #c3c3c2;" v-if="showPrivate">
      <el-checkbox-group v-model="company.classes" @change="classesChange">
        <el-checkbox v-for="item in categoryList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="table-title" style="margin-top:10px;" v-if="showPrivate">Private Information</div>
    <table class="attr-table" v-if="showPrivate">
      <tr>
        <td class="label">Address</td>
        <td v-html="company.address_br"></td>
        <td class="label">Ship Address</td>
        <td v-html="company.ship_address_br"></td>
      </tr>
      <tr>
        <td class="label">Phone</td>
        <td style="width:350px">1.&nbsp;{{ company.phone }}<span style="margin-left:20px;">2.&nbsp;{{ company.phone_2 }}</span></td>
        <td class="label" rowspan="3">Private Information</td>
        <td rowspan="3">{{ company.information }}</td>
      </tr>
      <tr>
        <td class="label">Fax</td>
        <td>1.&nbsp;{{ company.fax }}<span style="margin-left:20px;">2.&nbsp;{{ company.fax_2 }}</span></td>
      </tr>
      <tr>
        <td class="label">Web Page</td>
        <td v-if="company.web_page_href"><a :href="company.web_page_href" target="_blank">{{ company.web_page }}</a></td>
        <td v-else>{{ company.web_page }}</td>
      </tr>
      <tr>
        <td class="label">Email</td>
        <td>{{ company.email }}</td>
        <td class="label" rowspan="3">Company Note</td>
        <td rowspan="3" v-html="company.note_br"></td>
      </tr>
      <tr>
        <td class="label">Trade / Factory</td>
        <td>{{ company.type_1 }}</td>
      </tr>
      <tr>
        <td class="label">Supplier / Buyer</td>
        <td>{{ company.type_2 }}</td>
      </tr>
      <tr>
        <td class="label">Company Grade</td>
        <td>{{ company.grade }}&nbsp;
          <five-star :value="parseInt(company.grade)"></five-star>
        </td>
        <td class="label" rowspan="3" v-if="user.role_id < 3">Director Remark</td>
        <td rowspan="3" v-if="user.role_id < 3" class="hide-bg" v-html="company.director_remark_br"></td>
      </tr>
      <tr>
        <td class="label">Company Evaluation</td>
        <td>{{ company.evaluation }}</td>
      </tr>
    </table>

    <div class="table-title" style="margin-top:10px;" v-if="showPrivate">Contact Person</div>
    <table class="attr-table" v-if="showPrivate">
      <tr>
        <th>View</th>
        <th>Key</th>
        <th>Name</th>
        <th>Email</th>
        <th>Tel</th>
        <th>Mobile</th>
        <th>Fax</th>
      </tr>
      <tr v-for="item in contactList" :key="item.id" @click="selectContact = item">
        <td><input type="radio" id="contactRadio" :value="item" v-model="selectContact"></td>
        <td style="color:red;">{{ item.is_key === '1' ? '✔' : '' }}</td>
        <td>{{ item.respect }} {{ item.name }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.phone }}</td>
        <td>{{ item.mobile }}</td>
        <td>{{ item.fax }}</td>
      </tr>
    </table>

    <div v-if="showPrivate && selectContact.name" class="table-title" style="margin-top:10px;">{{ selectContact.name }}</div>
    <table class="attr-table" v-if="showPrivate && selectContact.name">
      <tr>
        <td class="label">Name</td>
        <td colspan="2">{{ selectContact.respect }} {{ selectContact.name }}</td>
        <td style="text-align:right;">
          <el-button @click="contactEdit">Edit</el-button>
        </td>
      </tr>
      <tr>
        <td class="label">Title</td>
        <td style="width:350px">{{ selectContact.job_title }}</td>
        <td class="label">Dept</td>
        <td>{{ selectContact.department }}</td>
      </tr>
      <tr>
        <td class="label">Tel</td>
        <td>{{ selectContact.phone }}</td>
        <td class="label">Fax</td>
        <td>{{ selectContact.fax }}</td>
      </tr>
      <tr>
        <td class="label">Mobile</td>
        <td>{{ selectContact.mobile }}</td>
        <td class="label">MSN</td>
        <td>{{ selectContact.msn }}</td>
      </tr>
      <tr>
        <td class="label">Email 1</td>
        <td>{{ selectContact.email }}</td>
        <td class="label">Email 2</td>
        <td>{{ selectContact.email_2 }}</td>
      </tr>
      <tr>
        <td class="label">Wechat</td>
        <td>{{ selectContact.wechat }}</td>
        <td class="label">QQ</td>
        <td>{{ selectContact.qq }}</td>
      </tr>
      <tr>
        <td class="label">Whatsapp</td>
        <td>{{ selectContact.whatsapp }}</td>
        <td class="label">Facebook</td>
        <td>{{ selectContact.facebook }}</td>
      </tr>
      <tr>
        <td class="label">Skype</td>
        <td>{{ selectContact.skype }}</td>
        <td class="label">Status</td>
        <td>{{ selectContact.status }}</td>
      </tr>
      <tr>
        <td class="label">Note</td>
        <td colspan="3" v-html="selectContact.remark_br"></td>
      </tr>
      <tr>
        <td colspan="4" style="text-align:right;">
          Create by {{ selectContact.create_oper_name }} at {{ selectContact.create_time }} <br/>
          Modified by {{ selectContact.update_oper_name }} at {{ selectContact.update_time }}
        </td>
      </tr>
    </table>
    <div style="margin-bottom:30px;margin-top:6px;" v-if="showPrivate">
      <el-button @click="contactNew">+ Add a new contact person</el-button>
    </div>
  </div>
</template>

<script>
import FiveStar from './FiveStar.vue'
import qs from 'qs'
export default {
  components: {
    FiveStar
  },
  data () {
    return {
      company: {
        id: this.$route.params.id,
        name: ''
      },
      selectContact: {
        id: 0,
        name: ''
      },
      contactList: [],
      customerGroupList: [],
      lastOfferCateList: [],
      lastRequireCateList: [],
      lastPOCateList: [],
      lastPICateList: [],
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    categoryList () {
      return this.$store.state.select.category
    },
    classList () {
      return this.$store.state.select.class
    },
    classListFilter () {
      return this.classList.filter(c => c.category_id === this.itemsParams.category_id)
    },
    contactKeyList () {
      return this.contactList.filter(c => c.is_key === '1')
    },
    showPrivate () {
      return this.user.role_id < 3 || this.user.id === this.company.sales_id || this.user.id === this.company.sales2_id
    },
    customerGroupListOffer () {
      return this.customerGroupList.filter(r => r.group_type === '0')
    },
    customerGroupListRequire () {
      return this.customerGroupList.filter(r => r.group_type === '1')
    }
  },
  mounted () {
    this.$store.dispatch('fetchSelect', 'category')
    this.$store.dispatch('fetchSelect', 'class')
    this.fetchCompany()
    this.fetchContactList()
    this.fetchCustomerGroupList()
    this.fetchLastOfferCateList()
    this.fetchLastRequireCateList()
    this.fetchLastPOCateList()
    this.fetchLastPICateList()
  },
  methods: {
    fetchCompany () {
      this.loading = true
      this.$http.get('/dbapi/company_list', {
        params: {
          id: this.$route.params.id
        }
      }).then(data => {
        this.loading = false
        if (data.list.length > 0) {
          this.company = data.list[0]
          this.company.classes = JSON.parse(this.company.classes)
          if (!this.company.web_page) {
            this.company.web_page_href = ''
          } else {
            this.company.web_page_href = this.company.web_page.trim()
            if (this.company.web_page_href.indexOf('http') !== 0) {
              this.company.web_page_href = 'http://' + this.company.web_page_href
            }
          }
        }
      })
    },
    fetchContactList () {
      this.$http.get('/dbapi/company_contact_list', {
        params: {
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.contactList = data.list
        if (this.contactList.length > 0) {
          this.selectContact = this.contactList[0]
        }
      })
    },
    fetchCustomerGroupList () {
      this.$http.get('/dbapi/group_company_list', {
        params: {
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.customerGroupList = data.list
      })
    },
    classesChange (val) {
      // DRAM 和 Flash IC 同时选中
      /*
      if (val.indexOf(1) >= 0) {
        if (val.indexOf(2) < 0){
          this.company.classes.push(2)
        }
      } else {
        if (val.indexOf(2) >= 0){
          this.company.classes.push(1)
        }
      }
      */
      this.$http.post('/dbapi/company_update_classes', {
        id: this.$route.params.id,
        classes: JSON.stringify(this.company.classes)
      }).then(result => {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
      })
    },
    edit () {
      this.$router.push('/customer/company/edit/' + this.$route.params.id)
    },
    contactNew () {
      this.$router.push('/customer/company/' + this.$route.params.id + '/contact/new')
    },
    contactEdit () {
      this.$router.push('/customer/company/' + this.$route.params.id + '/contact/' + this.selectContact.id)
    },
    fetchLastOfferCateList () {
      this.$http.get('/dbapi/company_last_offer_cate', {
        params: {
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.lastOfferCateList = data.list
      })
    },
    fetchLastRequireCateList () {
      this.$http.get('/dbapi/company_last_require_cate', {
        params: {
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.lastRequireCateList = data.list
      })
    },
    fetchLastPOCateList () {
      this.$http.get('/dbapi/company_last_po_cate', {
        params: {
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.lastPOCateList = data.list
      })
    },
    fetchLastPICateList () {
      this.$http.get('/dbapi/company_last_pi_cate', {
        params: {
          company_id: this.$route.params.id
        }
      }).then(data => {
        this.lastPICateList = data.list
      })
    }
  }
}
</script>